<template>
    <section ref="CheckupDate" class="gz-info-card__informers__item__container">
        <div            
            v-show="isActive"
            ref="CheckupDateActive"
            class="gz-info-card__informers__item" 
            style="cursor: pointer"
            @click.stop="setNextCheckupDate"
        >
            <span v-if="notification" title="Установите дату следующей проверки" class="icon-notification" style="margin-right: 5px"></span>
            <span class="icon-clipboard"></span>&nbsp;
            <span style="font-size: .7rem">{{ date | moment("DD-MM-YYYY") }}</span>
            <!-- <span class="icon-pencil" style="font-size: .7rem; margin-left: 10px"></span> -->
            <div>
                <span ref="DaysLeft" style="font-size: .7rem"></span>
            </div>
        </div>
        <div v-show="!isActive">
            <span class="icon-clipboard"></span>&nbsp;
            <span style="font-size: .7rem">{{ date | moment("DD-MM-YYYY") }}</span>
            <div>
                <span ref="DaysLeft" style="font-size: .7rem"></span>
            </div>
        </div>
    </section>
</template>

<script>
import NextCheckupDateModal from './NextCheckupDateModal'

export default {
    name: 'BaseNextCheckupDate',

    props: {
        date: String,
        type: String, //Передает в модальное окно значение 'address' или 'shelter'
        id: String, //Id дома или помещения
        isActive: {
        //Работает как кнопка или нет
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            notification: false
        }
    },
    computed: {
        dateComputed() {
            return this.date
        },
        daysLeftComputed() {
            return this.daysLeft
        }
    },
    mounted() {
        this.nextCheckupStatus()
    },
    methods: {
        nextCheckupStatus() {
            this.$refs.CheckupDate.classList.remove('gz-info-card__informers__item_soon')
            this.$refs.CheckupDate.classList.remove('gz-info-card__informers__item_tomorrow')
            this.$refs.DaysLeft.innerHTML = ''
            this.$refs.CheckupDate.style.color = ''
            
            //Считает разницу дней между текущей и указанной датой
            let day1 = this.$moment(new Date(this.dateComputed))
            let day2 = this.$moment(new Date())
            const daysLag = day1.diff(day2, 'days', false)

            if (!this.isActive) {
                if (daysLag > 0 && daysLag <= 3) {
                    this.$refs.CheckupDate.classList.add('gz-info-card__informers__item_soon')
                    this.$refs.DaysLeft.innerHTML = 'Осталось дней: ' + daysLag
                }

                if (daysLag === 1) {
                    this.$refs.DaysLeft.innerHTML = 'Проверка завтра'
                    this.$refs.CheckupDate.classList.add('gz-info-card__informers__item_soon')
                }

                if (this.$moment(day1).format('DD.MM.YY') === this.$moment(day2).format('DD.MM.YY')) {
                    this.$refs.DaysLeft.innerHTML = 'Проверка сегодня'
                    this.$refs.CheckupDate.style.color = '#ffffff'
                    this.$refs.CheckupDate.classList.add('gz-info-card__informers__item_tomorrow')
                }

                if (daysLag < 0 && !(this.$moment(day1).format('DD.MM.YY') === this.$moment(day2).format('DD.MM.YY'))) {
                    this.$refs.DaysLeft.innerHTML = 'Установите дату следующей проверки'
                }
            }

            if (this.isActive) {
                if (daysLag > 0 && daysLag <= 3) {
                    this.$refs.CheckupDateActive.classList.add('gz-info-card__informers__item_soon')
                    this.$refs.CheckupDateActive.title = 'Осталось дней: ' + daysLag
                }

                if (daysLag === 1) {
                    this.$refs.CheckupDateActive.title = 'Проверка завтра'
                    this.$refs.CheckupDateActive.classList.add('gz-info-card__informers__item_soon')
                }

                if (this.$moment(day1).format('DD.MM.YY') === this.$moment(day2).format('DD.MM.YY')) {
                    this.$refs.CheckupDateActive.title = 'Проверка сегодня'
                    this.$refs.CheckupDateActive.style.color = '#ffffff'
                    this.$refs.CheckupDateActive.classList.add('gz-info-card__informers__item_tomorrow')
                }

                if (daysLag < 0 && !(this.$moment(day1).format('DD.MM.YY') === this.$moment(day2).format('DD.MM.YY'))) {
                    this.$refs.CheckupDateActive.title = 'Установите дату следующей проверки'
                    this.notification = true
                }
            }
            
                
        },
        setNextCheckupDate() {
            this.$store.dispatch('modalOpen', {
                component: NextCheckupDateModal,
                data: {
                    type: this.type,
                    id: this.id
                }                
            })
        }
    },
    watch: {
        dateComputed: function(newVal) {
            this.nextCheckupStatus()
        }
    }
}
</script>